import React from 'react';
import SelectableAreaContext from './SelectableAreaContext';

const defaultBoundingRect = Object.freeze({
  x: 0,
  y: 0,
  width: 0,
  height: 0,
});

const createSelectableItem = (WrappedComponent) =>
  class SelectableItem extends React.Component {
    // eslint-disable-next-line react/static-property-placement
    static contextType = SelectableAreaContext;

    constructor(props) {
      super(props);
      this.node = null;
      this.boundingRect = null;
    }

    componentDidMount() {
      this.updateBoundingRect();

      const {selectable} = this.context;
      selectable.register(this);

      if (this.node) {
        this.node.addEventListener('mouseover', this.handleMouseOver);
        this.node.addEventListener('mouseleave', this.handleMouseLeave);
      }
    }

    componentWillUnmount() {
      const {selectable} = this.context;
      selectable.unregister(this);

      if (this.node) {
        this.node.removeEventListener('mouseover', this.handleMouseOver);
        this.node.removeEventListener('mouseleave', this.handleMouseLeave);
      }
    }

    handleMouseOver = () => {
      const {selectable} = this.context;
      if (selectable.disableSelectionOnHover) {
        selectable.setDisableSelection(true);
      }
    };

    handleMouseLeave = () => {
      const {selectable} = this.context;
      if (selectable.disableSelectionOnHover) {
        selectable.setDisableSelection(false);
      }
    };

    updateBoundingRect = () => {
      const boundingRect = {...defaultBoundingRect};
      if (this.node) {
        // to improve performance ? add documentScroll on arguments and no needs to call getBoundingClientRect again
        const nodeClientBoundingRect = this.node.getBoundingClientRect();
        const {x, y, width, height} = nodeClientBoundingRect;
        boundingRect.x = x + 0;
        boundingRect.y = y + 0;
        boundingRect.width = width;
        boundingRect.height = height;
      }
      this.boundingRect = boundingRect;
    };

    getSelectableRef = (ref) => {
      this.node = ref;
    };

    render() {
      // eslint-disable-next-line react/jsx-props-no-spreading
      return <WrappedComponent {...this.props} selectableRef={this.getSelectableRef} />;
    }
  };

export default createSelectableItem;
